import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import AppRoutes from './components/AppRoutes';

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}> 
      <AppRoutes />
    </LocalizationProvider>
  );
}

export default App;